<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M9.2 3.9V2H15v1.9zm2 10.5H13V8.7h-1.9zM12 22q-1.8 0-3.3-.7a9 9 0 0 1-4.6-4.6 8 8 0 0 1 0-6.6 9 9 0 0 1 4.6-4.6Q10.3 5 12 5a9 9 0 0 1 5.4 1.8l1.3-1.3L20 6.7 18.8 8q.9 1.2 1.4 2.6a9 9 0 0 1-2 8.9A9 9 0 0 1 12 22m0-1.9q2.7 0 4.7-2 2-1.9 2-4.7 0-2.7-2-4.7a6 6 0 0 0-4.7-2q-2.8 0-4.7 2a6 6 0 0 0-2 4.7q0 2.8 2 4.7 1.9 2 4.7 2"
    />
  </svg>
</template>
